<template>
  <div id="host" v-if="$csrf" class="min-vh-100 d-flex flex-column">
    <div class="main-body d-md-flex flex-grow-1">
      <div class="d-flex flex-column">
        <Topbar></Topbar>
        <Sidebar class="flex-grow-1"></Sidebar>
      </div>
      <main class="overflow-hidden flex-grow-1" style="background-color:#f4f8fb!important;">

        <div v-for="(message, index) in messages" :key="index">
          <div v-if="message.type == 'loader'" class="progress" style="border-radius:0;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" v-bind:class="'bg-' + message.status" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%">
              {{message.message}}
            </div>
          </div>
          <div v-else-if="message.type == 'alert'" class="alert alert-dismissible fade show mb-0 pb-2 pt-2" v-bind:class="'alert-' + message.status" role="alert" style="border-radius:0;" onload="alert('tralala')">
            {{message.message}}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="padding: 0.5rem 1.5rem;">
              <span aria-hidden="true" @click="hideMessage(index)">&times;</span>
            </button>
          </div>
        </div>


        <router-view id="main" :key="$route.params.property" v-bind.sync="{socket: socket}"></router-view>
      </main>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Topbar from '../navigation/topbar/Topbar';
import Sidebar from '../navigation/sidebar/Sidebar';
import Footer from '../footer/Footer';

import io from 'socket.io-client';

export default {
  name: 'Host',
  created(){
    //require('../../assets/css/bootstrap.css')
  },
  components: {
    'Topbar': Topbar,
    'Sidebar': Sidebar,
    'Footer': Footer
  },
  data: () => ({
    socket: io(process.env.VUE_APP_API),
    messages: [],
  }),
  mounted() {
    /*setInterval(() => {
      this.$worker.run((messages) => {
        let timestamp = Date.now();
        messages.filter(message => !message.displayed).map(message => {...message, displayed: timestamp});
        return messages.filter(message => message.displayed > (timestamp - 5000))
      }, [this.messages])
      .then(result => {
        this.messages = result;
      })
      .catch(e => {
        console.error(e)
      })
    }, 1000);*/

    this.deleteAlerts();

    this.socket.on('connect', () => {
      console.log('Connected');
    });

    this.socket.on('disconnect', (reason) => {
      console.log(`Disconnected: ${reason}`);
    });

    this.socket.on('statusMessage', (data) => {
      data = JSON.parse(data);
      let index = this.messages.findIndex(m => m.time == data.time);
      if(index > -1){
        if(data.type == 'loader'){
          this.messages.splice(index, 1, data)
          return;
        }
        this.messages.splice(index, 1);
      }
      this.messages.push(data);
    })
  },
  methods: {
    hideMessage: function(i){
      this.messages.splice(i, 1)
    },
    deleteAlerts(){
      this.$worker.run((messages) => {
        let timestamp = Date.now();
        messages.filter(message => !message.displayed).map(message => message.displayed = timestamp);
        return messages.filter(message => message.type != 'alert' || message.displayed > (timestamp - 10000))
      }, [this.messages])
      .then(result => {
        this.messages = result;
        return;
      })
      .then(() => setTimeout(this.deleteAlerts, 1000))
      .catch(e => {
        console.error(e)
      });
    }
  }
}
</script>
